/**
 * Converts a FilterState + CrudFilter[] config into a backend-compatible `where` clause.
 * All filters are combined with AND. Multi-select values use OR.
 */
function buildFilterWhere(filterState, filters) {
    const conditions = [];
    for (const filter of filters) {
        const key = filter.key;
        const value = filterState[key];
        if (value === undefined || value === '' || value === null)
            continue;
        switch (filter.type) {
            case 'multiselect': {
                const arr = value;
                if (arr.length === 0)
                    break;
                if (arr.length === 1) {
                    conditions.push({ [key]: arr[0] });
                }
                else {
                    // Use Prisma `in` operator for multiple values
                    conditions.push({ [key]: { in: arr } });
                }
                break;
            }
            case 'relation': {
                const str = value;
                if (str) {
                    conditions.push({ [key]: str });
                }
                break;
            }
            case 'text': {
                const str = value;
                if (str.trim()) {
                    conditions.push({ [key]: { contains: str.trim(), mode: 'insensitive' } });
                }
                break;
            }
            case 'boolean': {
                const bool = value;
                conditions.push({ [key]: bool });
                break;
            }
            case 'daterange': {
                const range = value;
                if (range.from || range.to) {
                    const dateFilter = {};
                    if (range.from)
                        dateFilter.gte = range.from;
                    if (range.to)
                        dateFilter.lte = range.to;
                    conditions.push({ [key]: dateFilter });
                }
                break;
            }
            case 'presence': {
                const str = value;
                if (str === 'present') {
                    conditions.push({ [key]: { not: null } });
                }
                else if (str === 'absent') {
                    conditions.push({ [key]: null });
                }
                break;
            }
        }
    }
    if (conditions.length === 0)
        return undefined;
    if (conditions.length === 1)
        return conditions[0];
    return { AND: conditions };
}
/**
 * Count the number of active filters in a FilterState
 */
function countActiveFilters(filterState) {
    let count = 0;
    for (const value of Object.values(filterState)) {
        if (isFilterActive(value))
            count++;
    }
    return count;
}
function isFilterActive(value) {
    if (value === undefined || value === null || value === '')
        return false;
    if (Array.isArray(value))
        return value.length > 0;
    if (typeof value === 'object') {
        const range = value;
        return Boolean(range.from || range.to);
    }
    return true;
}

export { buildFilterWhere, countActiveFilters };
//# sourceMappingURL=buildFilterWhere.js.map
